
import { border } from '@chakra-ui/react'
import { mode,darken,whiten } from '@chakra-ui/theme-tools'


export const ButtonStyles = {
    // style object for base or default style
    baseStyle: {},
    // styles for different sizes ("sm", "md", "lg")
    sizes: {
       
           
    },
    
    variants: {
        primary:(props)=>({
            bg:"primary",
            color: mode('white', 'black')(props),
            _hover:{
              
                boxShadow:"0 0 1px 2px #F68989"
            },
            borderRadius:"0px"
          
            
            
            
        }),
        secondary:(props)=>({
            bg:"secondary",
            color: mode('white', 'black')(props),
            _hover:{
               
                boxShadow:"0 0 1px 2px #B7CADB"
            },
            borderRadius:"0px"
        }),
        third:(props)=>({
            bg: mode('transparent', 'transparent')(props),
            color: mode('black', 'white')(props),
            _hover:{
                
                boxShadow:"0 0 1px 2px #A12568"
            },
            border:mode('1px solid black', '1px solid white')(props)
        }),
        
    },
    defaultProps: {
      size: '',
      variant: '',
      colorScheme: '',
    },
  }